import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthApi, JwtResponse, LoginRequest } from '@lkp/parking-sdk';
import { AUTH_API } from '../providers/api.module';
import { Subject, takeUntil, tap, Observable } from 'rxjs';
import { SetDriverMode, SetLoggedInUser } from '../states/users/user.actions';
import { SessionService } from './session.service';

const TOKEN_KEY = 'auth-token';
const ORDER_TOKEN_KEY = 'order-auth-token';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  authenticationState = this.sessionService.authenticationState;
  readonly onDestroy$ = new Subject();

  constructor(
    readonly router: Router,
    @Inject(AUTH_API) readonly authApi: AuthApi,
    readonly store: Store,
    private sessionService: SessionService
  ) {}

  ngOnDestroy(): void {
    this.onDestroy$.next(undefined);
    this.onDestroy$.complete();
  }

  authenticate(value: LoginRequest, driverMode: boolean = false): Observable<JwtResponse> {
    return this.authApi.authenticateUser({ loginRequest: value }).pipe(
      takeUntil(this.onDestroy$),
      tap((jwtResponse: JwtResponse) => {
        if (jwtResponse.jwt) {
          this.storeToken(jwtResponse.jwt);
          this.store.dispatch(new SetDriverMode(driverMode));
          this.sessionService.setAuthenticated(true);
          this.store.dispatch(new SetLoggedInUser());
        }
      })
    );
  }

  isAuthenticated() {
    return this.getToken();
  }

  logout(navigateToLogin: boolean = true) {
    this.sessionService.logout(navigateToLogin);
  }

  storeToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token);
  }

  storeOrderToken(token: string) {
    localStorage.setItem(ORDER_TOKEN_KEY, token);
  }

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  }

  getToken(): string | null {
    let token = localStorage.getItem(TOKEN_KEY);
    return token;
  }

  getOrderToken(): string | null {
    return localStorage.getItem(ORDER_TOKEN_KEY);
  }
}
